import Splide from '@splidejs/splide';

window.homepageSlideshow = {
    _node: null,
    _slider: null,
    timeout: false,
    delay: 250,

    init() {
        this._node = document.querySelector('.c-slideshow');
        if (this._node) {
            this._build();
        }
    },

    reInit() {
        this._node = document.querySelector('.c-slideshow');

        if (! this._node) {
            if (this._slider) {
                this._destroy();
            }

            return;
        }

        if (this._slider && this._slider.root === this._node) {
            return;
        }

        if (this._slider) {
            this._destroy();
        }

        this._build();
    },

    _build() {
        this._slider = new Splide(this._node, {
            type: 'fade',
            rewind: true,
            speed: 800,
            interval: 4000,
            perPage: 1,
            accessibility: true,
            arrows: false,
            keyboard: true,
            autoplay: true,
            pagination: true,
        }).mount();

        this._update();
    },

    _destroy() {
        this._slider.destroy(true);
        this._slider = null;
    },

    _update() {
        window.lazyLoadInstance.update();
    }
};

window.homepageSlideshow.init();

document.addEventListener('LokiRequestEnd', () => {
    window.homepageSlideshow.reInit();
});

window.addEventListener('resize', () => {
    clearTimeout(homepageSlideshow.timeout);

    window.homepageSlideshow.timeout = setTimeout(() => {
        window.homepageSlideshow._update();
    }, window.homepageSlideshow.delay);
});
